import { createSlice } from "@reduxjs/toolkit";

export enum AssessmentPageContentType {
  StepsToRecord,
  Record
}

export type CreateNewAssessmentShellState = {
  contentType: AssessmentPageContentType;
};

const initialState: CreateNewAssessmentShellState = {
  contentType: AssessmentPageContentType.StepsToRecord
};

/** Create assessment shell Slice */
const { reducer, actions } = createSlice({
  name: "createNewAssessmentShell",
  initialState,
  reducers: {
    setContentType: (state, { payload }) => {
      state.contentType = payload;
    }
  }
});

export const { setContentType } = actions;

export default reducer;
